var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n  flex-grow: 0;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n  flex-grow: 0;\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import 'font-awesome/css/font-awesome.css';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import { Nav } from '../Nav';
import MemberDropdown, { MobileTopMenu } from '../MemberDropdown';
import SidePanel from '../SidePanel';
import { SearchIconMobile, HamburgerIcon } from '../Icons';
import { BurgerBox, AuthBox, MenuBox, MobileButtonGroup } from './styled';
import getPgaTld from '../../getPgaTld';

export var IconsBox = styled.div(_templateObject);

var pgaTld = getPgaTld();

export var MobileNavigation = function (_Component) {
  _inherits(MobileNavigation, _Component);

  function MobileNavigation(props) {
    _classCallCheck(this, MobileNavigation);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      open: false
    };
    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  MobileNavigation.prototype.onClick = function onClick() {
    this.setState({ open: !this.state.open });
  };

  MobileNavigation.prototype.render = function render() {
    var _props = this.props,
        options = _props.options,
        linkComponent = _props.linkComponent,
        menuOptions = _props.menuOptions,
        me = _props.me,
        comp = _props.comp,
        b = _props.b,
        l = _props.l,
        isLoggedIn = _props.isLoggedIn,
        meEmailMigrationData = _props.meEmailMigrationData,
        onToggleDoNotShowAgain = _props.onToggleDoNotShowAgain;

    return React.createElement(
      Fragment,
      null,
      React.createElement(
        MobileButtonGroup,
        null,
        React.createElement(
          'a',
          { href: 'http://resources.' + pgaTld },
          React.createElement(SearchIconMobile, null)
        ),
        React.createElement(
          BurgerBox,
          { onClick: this.onClick },
          React.createElement(HamburgerIcon, null)
        )
      ),
      React.createElement(
        SidePanel,
        { open: this.state.open, onClose: this.onClick },
        React.createElement(
          AuthBox,
          null,
          React.createElement(
            MediaQuery,
            { minWidth: 992 },
            React.createElement(MemberDropdown, { me: me, options: options, menuOptions: menuOptions, flat: true })
          ),
          React.createElement(
            MediaQuery,
            { maxWidth: 991 },
            React.createElement(MobileTopMenu, { me: me, menuOptions: menuOptions, comp: comp })
          )
        ),
        React.createElement(
          MenuBox,
          null,
          React.createElement(Nav, { options: options, comp: linkComponent || null, b: b, l: l, vertical: true, isLoggedIn: isLoggedIn, meEmailMigrationData: meEmailMigrationData, onToggleDoNotShowAgain: onToggleDoNotShowAgain, me: me })
        )
      )
    );
  };

  return MobileNavigation;
}(Component);

MobileNavigation.propTypes = process.env.NODE_ENV !== "production" ? {
  me: PropTypes.object,
  options: PropTypes.array.isRequired,
  menuOptions: PropTypes.array,
  b: PropTypes.number,
  l: PropTypes.number,
  linkComponent: PropTypes.func,
  comp: PropTypes.func
} : {};

export default MobileNavigation;